
export class PopTituloPrincipalInsert {
  public texto: string;

  constructor(texto: string ) {
    this.texto = texto;
  }
}